// extracted by mini-css-extract-plugin
export default {"segmented":"index_segmented__kVkLT"};